var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo--linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6575 3.00002H4.3425C3.99354 2.99793 3.65764 3.13255 3.40671 3.37506C3.15579 3.61757 3.0098 3.9487 3 4.29752V19.65C3.00788 19.9995 3.15327 20.3317 3.40461 20.5747C3.65596 20.8176 3.99297 20.9516 4.3425 20.9475H19.6575C20.007 20.9516 20.344 20.8176 20.5954 20.5747C20.8467 20.3317 20.9921 19.9995 21 19.65V4.29752C20.9902 3.9487 20.8442 3.61757 20.5933 3.37506C20.3424 3.13255 20.0065 2.99793 19.6575 3.00002ZM8.3325 18.3075H5.6925V9.75002H8.3325V18.3075ZM7.0425 8.55752C6.63717 8.55764 6.24786 8.39923 5.95777 8.11615C5.66767 7.83306 5.49979 7.44774 5.49 7.04252C5.48266 6.83667 5.5178 6.63151 5.59322 6.43983C5.66864 6.24815 5.78273 6.07406 5.92839 5.92841C6.07404 5.78276 6.24813 5.66867 6.43981 5.59324C6.63149 5.51782 6.83665 5.48268 7.0425 5.49002C7.43463 5.51733 7.80181 5.69236 8.06993 5.9798C8.33805 6.26725 8.48716 6.64569 8.48716 7.03877C8.48716 7.43186 8.33805 7.8103 8.06993 8.09774C7.80181 8.38519 7.43463 8.56022 7.0425 8.58752V8.55752ZM18.36 18.255H15.75V14.07C15.75 13.0725 15.75 11.775 14.355 11.775C12.96 11.775 12.75 12.87 12.75 13.9725V18.21H10.08V9.75002H12.57V10.875H12.6225C12.8777 10.4318 13.2499 10.0672 13.6983 9.82122C14.1467 9.5752 14.6541 9.45717 15.165 9.48002C17.8575 9.48002 18.36 11.28 18.36 13.5675V18.255Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4c384ef68501cdcc73d30a47ddc209b8.svg";
export { ForwardRef as ReactComponent };